export const VerifiedWithNoOrderTemplate = {
    name: 'verified_with_no_order',
    label: 'Verified with no order',
    subject: 'Your first REBIT is zero-fee!',
    category: 'reminders',
    body: "<p>Well done, ${first_name}!</p>"
        + "<p>✅ You have completed the initial steps to unlock your Rebit account.</p>"
        + "<p>💟 From then on, creating your first transfer is super simple. </p>"
        + "<p>💴 We monitor our exchange rates regularly to ensure you get the best deals in the market.</p>"
        + "<p>🚀 Wait no more…</p>"
        + "<p style='padding-bottom: 10px;text-align: center; font-weight: bold; font-size: 18px'>"
        + "<a href='https://my.rebitmoney.com/transfers/send-money' style='text-decoration: none' class='action-button bg-input-color text-white'>SEND MONEY NOW</a>"
        + "</p>"
        + "<p>Any concerns?  Hit REPLY (support@rebit.co.nz) and let us know what’s stopping you. We’ll do our best to make it work for you.</p>"
        + "<p>Rebit Team</p>"
}
